var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 29,
    viewBox: "0 0 39 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_97)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4604 7.12675L17.1958 27.3914C15.6967 28.8905 13.2593 28.8905 11.7603 27.3914L1.299 16.9301C-0.200089 15.431 -0.200089 12.9937 1.299 11.4946C2.79809 9.99551 5.23545 9.99551 6.73454 11.4946L14.478 19.2381L32.0249 1.69121C33.524 0.192123 35.9613 0.192123 37.4604 1.69121C38.9595 3.1903 38.9595 5.62766 37.4604 7.12675Z",
    fill: "#253748"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_97"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38.4155,
    height: 27.9542,
    fill: "white",
    transform: "translate(0.177246 0.56958)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.869a10844d26668461522c8c4e3f219b.svg";
export { ForwardRef as ReactComponent };